import React from 'react';
import { SelectDropdown } from '@prosolve/common-components-ui';

// Picker for an assessment mod (stores the mod's _id, displays its modName).
// Parents only render this when the selected target assessment actually has mods.
export default ({
  value = '',
  modOptions = [],
  onChange,
  disabled,
  width = '220px'
}) => {
  const options = [
    { value: '', text: 'No mod' },
    ...modOptions
  ];

  // Keep a saved mod visible even if it no longer exists
  if (value && !modOptions.some(({ value: optionValue }) => optionValue === value)) {
    options.push({ value, text: 'Saved mod (missing)' });
  }

  return (
    <SelectDropdown
      options={options}
      value={value}
      onChange={(newValue) => {
        if (newValue !== value) {
          onChange(newValue)
        }
      }}
      width={width}
      disabled={disabled}
    />
  )
}
